import { useCallback, useEffect, useMemo, useState } from 'react'
import { usePrimaryCta } from '@mc/growth'
import { getPageSource, NavigationEvents, track } from '@mc/track-event'
import Sticky from 'components/Sticky'
import { StickyContent } from './StickyContent'
import { useConfig } from './useConfig'

interface StickyFooterProps {
  customHref?: string
  trackProps?: Record<string, string>
}

export const StickyFooter = ({ customHref, trackProps }: StickyFooterProps) => {
  const [pageSourceTrack, setPageSourceTrack] = useState<string>()
  const { config } = useConfig()
  const { ctaCopy } = usePrimaryCta()

  const trackData = useMemo(
    () => ({
      content_type: 'product',
      location: 'sticky_footer',
      page_source: pageSourceTrack,
      ...trackProps,
    }),
    [trackProps, pageSourceTrack],
  )

  const trackNavigationClicked = useCallback(
    (action: string) =>
      track(NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
        action,
        location: trackData.location,
        page_source: trackData.page_source,
      }),
    [trackData],
  )

  useEffect(() => {
    setPageSourceTrack(getPageSource())
  }, [])

  return (
    <Sticky config={config}>
      <div id='sticky-footer' data-testid='sticky-footer'>
        <StickyContent
          ctaProps={{
            href: customHref,
            trackProps: trackData,
            onClick: trackNavigationClicked,
            children: ctaCopy,
          }}
        />
      </div>
    </Sticky>
  )
}
